<template>
  <CBox minHeight="100vh"
width="100vw" position="sticky">
    <omint-page>
      <Header titleLabel="Serviços Omint" />
      <OmtGrid>
        <OmtRow>
          <CGrid template-columns="repeat(2, 1fr)"
gap="2">
            <OmtCard
              v-for="(m, index) in services"
              :key="`${index}-${m.Label}`"
              data-cy="service-card"
              mb="5"
              cursor="pointer"
              @click="navigate(m.View, m.Label)"
            >
              <OmtIcons :name="m.Icon"
size="xl" mb="4" />
              <OmtTypography as="h3-bold"
mb="0" minHeight="40px">{{ m.Label }}</OmtTypography>
              <OmtTypography
                as="p1"
                color="var(--colors-light-primary-gray2)"
                minHeight="80px"
                m.Description
                }}<
                OmtTypography
            /></OmtCard>
          </CGrid>
        </OmtRow>
      </OmtGrid>
      <Footer />
    </omint-page>
  </CBox>
</template>

<script>
import Footer from "@/components/Molecules/Footer";
import Header from "@/components/Molecules/Header";
import { isMobile } from "@/utils/utils";
import { mapState } from "vuex";

export default {
  components: {
    Header,
    Footer
  },
  computed: {
    ...mapState("saude", ["menu"]),
    baseUrl() {
      return `${document.location.protocol}//${document.location.host}`;
    },
    services() {
      if (!this.menu?.length) return [];
      return this.menu.filter(m => !m.Desktop);
    }
  },
  mounted() {
    this.$root.$emit("hide-loading");
  },
  methods: {
    navigate(link) {
      if (link) {
        const internalLink = link.startsWith("/") || link.startsWith(this.baseUrl);
        if (!internalLink || link !== this.$router.currentRoute.path) {
          try {
            if (internalLink) {
              this.$router.push(link);
            } else if (isMobile()) {
              globalThis.window.location.href = link;
            } else {
              globalThis.window.open(link, "_blank", "noopener,noreferrer");
            }
          } catch (error) {
            return error;
          }
        }
      }
    }
  }
};
</script>
